<template>

	<div :class="{'menu-options':true,side:side,sub:sub,main:!side&&!sub}">
		<router-link 
			:key="'top-menu-stats'"
			:to="'/'+baseURI+'/stats/'+md5Key" 
			v-if="!sub&&!side"
			exact 
		>Overview</router-link>
		<router-link
			v-for="(tab,tabIndex) in tabs2" 
			:key="tab._id"
			:to="url(tab)" 
			:class="tabClasses(tab)"
			exact 
		><span v-if="tabSelected(tab)&&editIndex!==tabIndex" @click="tabClicked(tab,tabIndex)">{{tab.label}}</span><span v-if="!tabSelected(tab)">{{tab.label}}</span><input type="text" v-model="inputText" @keyup.enter="saveTab(tab)" @blur="saveTab(tab)" @keyup.escape="escTab" :ref="'input-'+tabIndex" v-if="tabSelected(tab)&&editIndex===tabIndex"> <font-awesome-icon class="edit" icon="pencil-alt" :style="{ color: '#3b445b' }" v-if="tabSelected(tab)&&editIndex!==tabIndex&&sub" @click="tabClicked(tab,tabIndex)" /> <Tip position="fromRight" :class="{mini:true,theTip:true,grey:true}" v-if="tipsByType(tab.type)">{{tipsByType(tab.type)}}</Tip></router-link>
		<span 
			v-if="sub&&!readOnly"
			@click="newTab"
			class="addNewTab"
		>+ New Tab</span>

		<div
			v-if="subTabId&&!readOnly"
			class="large-button mini delete-tab"
			@click="deleteTab"
		>Delete current tab</div>
	</div>

</template>
<script>
import { mapMutations } from 'vuex'
import Tip from './../Tip.vue'
export default {
	name: 'TopMenu',
	components: { Tip },
	props: {
		tabs: {
			type: Array
		},
		tips: {
			type: Object
		},
		baseURI: {
			type: String,
			default: 'content-and-keywords'
		},
		md5Key: {
			type: String
		},
		tabId: {
			type: String
		},
		subTabId: {
			type: String
		},
		tabType: {
			type: String
		},
		side: {
			type: Boolean,
			default: false
		},
		sub: {
			type: Boolean,
			default: false
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			editIndex: {
				type: Number,
				default: -1
			},
			inputText: {
				type: String,
				default: ''
			}
		}
	},
	computed: {

		tabs2 () {

			let tabs = [];

			this.tabs.forEach(tab => {
				
				if ( tab.type === 'easy' ) return; 

				tabs.push(tab);

			});

			return tabs;

		}

	},
	methods: {

		...mapMutations('general',['reloadInstructionalTips']),

		tipsByType (type) {

			return ( this.tips && typeof this.tips[type] !== 'undefined' ) ? this.tips[type] : '';

		},

		deleteTab () {

			this.$emit('deleteTab');

		},

		saveTab (tab) {

			if ( this.inputText !== '' ) {

				this.$emit('saveTab',{ label: this.inputText, tab: this.tabs[this.editIndex], index: this.editIndex });

				this.escTab ();

			}

		},

		escTab () {

			this.editIndex = -1;
			this.inputText = '';

		},

		tabClicked(tab,tabIndex) {

			if ( this.sub ) {
				
				this.editIndex = tabIndex;
				this.inputText = tab.label;
				setTimeout( function () { this.$refs['input-'+tabIndex][0].select(); }.bind(this), 100 );
			
			}

		},

		tabSelected (tab) {

			let s = false;

			if ( this.sub ) {

				if ( this.$route.params.subTabId ) {

					if ( !tab.default ) s = this.$route.params.subTabId === tab._id.toString();

				}
				else if ( tab.default ) {

					s = true;

				}

			}
			else {

				s = this.$route.params.tabId === tab._id.toString();

			}

			return s;

		},

		tabClasses(tab) {

			let c = {
				hasTip: true
			};

			c.selected = this.tabSelected (tab);
			c[this.name(tab)] = true;

			return c;

		},

		url (tab) {

			if ( this.sub ) {

				return '/'+this.baseURI+'/'+this.tabType+'/'+this.md5Key+'/'+this.tabId + ( tab.default ? '' : '/' + tab._id.toString() );

			}
			else {

				return '/'+this.baseURI+'/'+tab.type+'/'+this.md5Key+'/'+tab._id.toString()

			}

		},
		name (tab) {

			return this.sub ? this.tabType : tab.type;

		},
		
		newTab () {

			this.$emit('newTab');

		}
	},
	mounted () {

		this.reloadInstructionalTips();

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.menu-options {

	&.main {

		border-radius: 10px 10px 0 0;

	}

	.theTip {

		position: absolute;
		top: 7px;
		right: 2px;
		z-index: 2;

	}

	> a, > span {

		display: inline-block;
		text-decoration: none;
		margin: 0 15px 10px 0;
		padding: 5px 10px;
		color: @darkContrast;
		position: relative;

		span {

			color: inherit;

		}

		&.addNewTab {

			.opacity(0.75);
			color: @formDefaultColour;

		}

		&.hasTip {

			padding-right: 16px;

			span {

				display: inline-block;
				padding-right: 3px;

			}

		}

	}

	input {
		border: none;
		padding: 0;
		font-size: inherit;
		outline: none;
	}

	&.sub {

		border-top: 1px solid;

		svg {
			width: 15px;
		}

	}

	&:not(.sub) {

		> a, > span {

			&.router-link-active {

				background: @darkContrast;
				color: #fff;
				padding: 5px 10px;

				&.hasTip {

					padding-right: 16px;

				}

			}

		}

	}

}

.delete-tab {
	display: none;
}

@media screen and (min-width: 960px) {

	.delete-tab {

		display: inline-block;	
		margin: 0 0 0 5px;	

	}

	.menu-options {

		position: relative;
		left: -15px;
		top: 0;
		width: calc(100% + 30px);
 
		> a, > span {

			padding: 10px 15px;
			margin: 0;
            cursor: pointer;
			text-align: center;

            &.router-link-active, &:hover, &.selected {

                text-decoration: none;
				padding: 10px 15px;
				.opacity(1);

            }

		}

		.theTip {

			top: 4px;

		}

		&.sub {

			border: none;
			padding-left: 10px;

			> a, > span {

				padding: 10px 5px 0;

				&.selected, &:hover {

					span {

						text-decoration: underline;

					}

				}

				&:after {

					content: '';
					display: inline-block;
					width: 1px;
					height: 14px;
					background-color: @darkContrast;
					margin-left: 10px;


				}

				&:last-child {

					&:after {

						display: none;

					}

				}

			}

		}

		&:not(.sub) {

			display: flex;
  			justify-content: space-between;

			> a, > span {

				color: #fff;

				&.router-link-active, &:hover, &.selected {

					background-color: white;
                	color: @darkContrast;

				}

				&.router-link-active, &.selected {

					cursor: default;
					font-weight: @bold;
					padding: 10px 15px;

				}

			}

		}

		&.main {

			background-color: @darkContrast;

			> a, > span {

				&:first-child {

					padding-left: 30px;

				}

				&:last-child {

					padding-right: 30px;

					.theTip {

						right: 5px;

					}

				}

			}

		}

		&.side {

			position: relative;
			width: 15%;
			left: 0;
			min-height: 100%;
			display: block;
			z-index: 3;
			padding-top: 10px;
			box-shadow: 7px 0px 11px -14px rgba(0,0,0,0.75);
			-webkit-box-shadow: 7px 0px 11px -14px rgba(0,0,0,0.75);
			-moz-box-shadow: 7px 0px 11px -14px rgba(0,0,0,0.75);

			> a, > span {

				text-align: left;
				display: block;
				position: relative;
				box-sizing: border-box;
				font-size: 0.9vw;
				color: @darkContrast;
				.rounded(5px);

				&:hover {

					text-decoration: underline;

				}

				&.router-link-active, &.selected {

					width: 106%;
					padding-left: calc( 3% + 15px );
					left: -3%;
					background-color: @darkContrast;
					color: #fff;

					&:hover {

						text-decoration: none;

					}

				}

			}

		}

	}
}
</style>